import MessageBox from "sap/m/MessageBox";

export enum MessageBoxActionType {
  YESNO = "YESNO",
  OKCANCEL = "OKCANCEL"
}

export default class MessageBoxHandler {

  public static showError(message: string) {
    MessageBox.error(message);
  }

  public static showActionWithYesAndNoButton(title: string, message: string, callbackSuccessConfirmation?: (...args: any[]) => any | undefined, callOnClose?: (...args: any[]) => any | undefined) {
    this.showMessageBoxConfirmation(title, message, MessageBoxActionType.YESNO,
      (oAction) => {
        if (oAction === MessageBox.Action.YES) {
          if (callbackSuccessConfirmation) {
            callbackSuccessConfirmation();
          }
        }
        if (callOnClose) {
          callOnClose();
        }
      });
  }

  public static showActionWithOkAndCancelButton(title: string, message: string, callbackSuccessConfirmation?: (...args: any[]) => any | undefined, callOnClose?: (...args: any[]) => any | undefined) {
    this.showMessageBoxConfirmation(title, message, MessageBoxActionType.OKCANCEL,
      (oAction) => {
        if (oAction === MessageBox.Action.OK) {
          if (callbackSuccessConfirmation) {
            callbackSuccessConfirmation();
          }
        }
        if (callOnClose) {
          callOnClose();
        }
      });
  }


  public static showMessageBoxConfirmation(title: string, message: string, messageBoxActionType: MessageBoxActionType, onClose?: (oAction: string) => any | undefined) {
    let actions = [MessageBox.Action.YES, MessageBox.Action.NO];

    if (MessageBoxActionType.OKCANCEL === messageBoxActionType) {
      actions = [MessageBox.Action.OK, MessageBox.Action.CANCEL];
    }
    MessageBox.warning(message, {
      title: title,
      actions: actions,
      onClose: (oAction) => {
        onClose(oAction);
      },
    });
  }
}